import React, { useEffect } from 'react';
import { useState } from "react";
import getUrl from "../../../../../Utility/GetUrl";
import {BiEdit} from 'react-icons/bi';
import {AiFillDelete} from 'react-icons/ai';
import { Link } from "react-router-dom";
import { fetchData } from '../../../../../Utility/GlobalService';

const PortfolioList = ()=>{
    useEffect(async()=>{
        await getPortfolioData();
    },[]);
    const [work,setWorkData] = useState([]);
    const getPortfolioData = async()=>{
        const workData = await fetchData(`${getUrl()}/work`);
        // return workData;
        setWorkData(workData);
        // console.log(work);
    }
    // await getPortfolioData();
    return (
        <div className="card">
            <div className="card-body mb-auto">
                <h5>Portfolio List</h5>
                <table className="table table-bordered">
                    <tr>
                        <th>Name</th>
                        <th>Live Link</th>
                        <th>Edit</th>
                        <th>Delete</th>
                    </tr>
                    {work && work.map((data)=>{
                        return (<tr key={data._id} >
                            <td>{data.projectname}</td>
                            <td><a href={data.livelink}>{data.livelink}</a></td>
                            <td>
                                <Link to={`/dashboard/work/${data._id}`}>
                                    <button className="btn btn-sm btn-warning">
                                            <span><BiEdit style={{color: '#fff !important'}} className="icon"/></span>
                                    </button>
                                </Link>
                            </td>
                            <td>
                                <button className="btn btn-sm btn-danger">
                                        <span><AiFillDelete className="icon"/></span>
                                </button>
                            </td>
                        </tr>)
                    })}
                </table>
            </div>
        </div>
    )
}
export default PortfolioList;